// Thin React-side wrapper over the shared privacy store (public/privacy-store.js).
//
// The store itself is plain script rather than a module because the Consent Mode
// defaults and the Meta Pixel gate in index.html have to run long before the
// bundle is parsed. This file is just the door into it from React, so the app
// never keeps its own private copy of the visitor's choice.
//
// Nothing here throws. A failed preference read must not take a screen down with
// it, so every accessor degrades to the safe answer instead.

const store = () => (typeof window === "undefined" ? null : window.QushiPrivacy);

export const readPrefs = () => {
  try {
    const P = store();
    return P ? P.read() : null;
  } catch (e) {
    return null;
  }
};

// True when the visitor is in a region where nonessential tags need consent
// BEFORE they may collect (EEA, UK, Switzerland).
export const isPriorConsentRegion = () => {
  try {
    const P = store();
    return P ? P.isPriorConsentRegion() : false;
  } catch (e) {
    return false;
  }
};

// True once the visitor has answered the consent banner, either way.
export const hasAnsweredBanner = () => {
  try {
    const P = store();
    return P ? P.hasAnsweredBanner() : false;
  } catch (e) {
    return false;
  }
};

// The sale/share opt-out, which a Global Privacy Control signal also triggers on
// its own. Advertising only - it never covers analytics.
export const isAdOptOut = () => {
  try {
    const P = store();
    return P ? P.adOptOut() : false;
  } catch (e) {
    return false;
  }
};

// Merge a change into the stored choice, push it to Consent Mode, and let any
// consent-gated tag that is still waiting start up.
export const savePrefs = (changes) => {
  try {
    const P = store();
    if (!P) return null;

    const prefs = { ...(P.read() || {}), ...changes, v: 1, updatedAt: Date.now() };
    P.write(prefs);
    P.applyConsent(prefs);

    // The Meta Pixel is not loaded at all until advertising consent exists, so
    // a visitor who accepts mid-session needs it started now rather than on the
    // next page load.
    if (typeof window.qushiLoadMetaPixelIfAllowed === "function") {
      window.qushiLoadMetaPixelIfAllowed();
    }
    return prefs;
  } catch (e) {
    return null;
  }
};
